import * as angular from 'angular';
import * as d3 from 'd3';
import * as _ from 'lodash';

import { ComponentDefinition, ConstraintResult, IdentifierType } from '../../models';
import { IIdentifierVmService } from '../../services';
import { Kpi } from '../../wtFramework';

class ReconciliationEquationController implements angular.IComponentController {
    identifiers: any[];
    isLoading: boolean;
    kpiTuples: any[];
    loadingMessage: string = 'Updating display';
    results: ConstraintResult[];

    private _garbages: (() => void)[] = [];

    static $inject = ['$scope', 'identifierVmService'];

    constructor(
        private _$scope: angular.IScope,
        private _identifierVmService: IIdentifierVmService) {
    }

    $onInit() {
        this._garbages.push(this._$scope.$watch(() => this.results, () => {
            if (this.results) {
                this.refresh();
            }
        }));
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    private refresh() {
        this.isLoading = true;
        let res = _.sortBy(this.results, r => r.name);
        res = res.reverse();
        if (res && res.length > 0) {
            this.refreshKpi(res);
        } else {
            this.refreshEmptySeries();
        }
    }

    refreshKpi(res: ConstraintResult[]) {
        this._identifierVmService
            .getViewModelsFromApiFromGuidList(this.results.map(d => d.identifierGuid))
            .then(data => {
                this.kpiTuples = res.map(d => {
                    const item = _.find(data, dd => dd.guid === d.identifierGuid);
                    const kpi: Kpi = {
                        name: d.name,
                        value: d.reconciledValue,
                        min: d.min,
                        max: d.max,
                        /*globalMin: -1e-3,
                        globalMax: 1e-3,*/
                        target: d.target,
                        quality: null,
                        color: Math.abs(d.reconciledValue - d.target) > 1e-6 ? 'red' : '#c36',
                        unit: item.unitName,
                        variation: 0,
                        context: '',
                        identifier: d.identifierGuid
                    };
                    return {
                        kpi: kpi,
                        item: item,
                        options: {
                            isContextVisible: false,
                            isTendencyVisible: false,
                            isQualityVisible: false,
                            isTargetVisible: true,
                            isRangeVisible: true,
                            decimals: 2,
                            valueFormat: d3.format('2.2f')
                        }
                    };
                });
            })
            .finally(() => this.isLoading = false);
    }

    refreshEmptySeries() {
        this.kpiTuples = this.identifiers
            .filter(i => i.type === IdentifierType.CalculatedValue)
            .map(d => {
                const kpi: Kpi = {
                    name: d.name,
                    value: 0,
                    min: d.min,
                    max: d.max,
                    target: d.target,
                    quality: null,
                    color: '#c36',
                    unit: d.unitName,
                    variation: 0,
                    context: '',
                    identifier: d.identifierGuid
                };
                return {
                    kpi: kpi,
                    options: {
                        isContextVisible: false,
                        isTendencyVisible: false,
                        isQualityVisible: false,
                        isTargetVisible: true,
                        isRangeVisible: true,
                        decimals: 2,
                        valueFormat: d3.format('2.2f')
                    }
                };
            });
        this.isLoading = false;
    }
}

export const wtReconciliationEquation: ComponentDefinition = {
    componentId: 'wtReconciliationEquation',
    controller: ReconciliationEquationController,
    template: require('./reconciliationEquation.component.html'),
    controllerAs: 'vm',
    bindings: {
        results: '<',
        identifiers: '<'
    }
};
